
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate/success",
      function () {
        return require("private-next-pages/activate/success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activate/success"])
      });
    }
  